import { client } from "#api/client.ts";
import { client as migrateClient } from "#api/migrate-web/client.ts";
import { usePaths } from "#paths.ts";
import { type SgWorkspace, WorkspaceBoundary, getHomePaths } from "@sg-protect/shell";
import { type PropsWithChildren, useCallback, useMemo } from "react";
import { generatePath } from "react-router";

export function ModuleWorkspaceBoundary({ children }: PropsWithChildren) {
    const paths = usePaths({ prefillWorkspaceId: false });
    const clients = useMemo(() => [migrateClient, client], []);

    const resolveDestination = useCallback(
        (workspace: SgWorkspace) => {
            if (workspace.isPartner) {
                return getHomePaths(workspace.id).root;
            }

            return generatePath(paths.root, { workspaceId: workspace.id });
        },
        [paths.root]
    );

    return (
        <WorkspaceBoundary resolveDestination={resolveDestination} client={clients}>
            {children}
        </WorkspaceBoundary>
    );
}
